import { BaseConfig } from './base-config.interface';
import { config } from './specific/config';

export const base: BaseConfig = {
  version: '0.37.0',
  ...config,
};
